import { Box, Typography } from '@mui/material';
import React from 'react';
import TLAHousingLine from '../static/TLAhousingline.png';
import EOC from '../static/eocimage.png';
import Finance from '../static/financecontact.png';
import { useResponsive } from '../hooks/useResponsive';

const Contact = ({
  img,
  alt,
  children,
}: {
  img: string;
  alt: string;
  children: React.ReactNode;
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ paddingBottom: '16px' }}>
        <img alt={alt} width='250px' height='100px' src={img} />
      </Box>
      <Box sx={{ margin: '0 8px', overflow: 'break-word' }}>
        <Box>{children}</Box>
      </Box>
    </Box>
  );
};

type ContactTextVariant = 'bold' | 'normal';

const ContactText = ({
  variant = 'normal',
  children,
}: {
  variant?: ContactTextVariant;
  children: React.ReactNode;
}) => {
  return (
    <Typography
      sx={{
        paddingBottom: '12px',
        color: 'rgba(0, 0, 0, 0.6);',
        fontWeight: variant,
      }}
      variant='body2'
    >
      {children}
    </Typography>
  );
};

const ContactList = () => {
  const { isMobile } = useResponsive();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography sx={{ paddingBottom: '16px' }} variant='h3'>
        GET IN TOUCH!
      </Typography>
      <Typography
        letterSpacing='3px'
        lineHeight='24px'
        sx={{
          fontSize: '13px',
          padding: isMobile ? '0px 8px 32px 8px' : '0 0 88px 0',
          margin: isMobile ? '8px' : '0px',
          textAlign: 'center',
        }}
      >
        THIS WEBSITE IS FOR DEPARTMENT OF THE AIR FORCE PERSONNEL ON OAHU
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: isMobile ? '56px' : '120px',
        }}
      >
        <Contact alt='Finance Image' img={Finance}>
          <ContactText variant='bold'>FINANCE</ContactText>
          <ContactText>Email: 15cpts.fmf.2@us.af.mil</ContactText>
        </Contact>
        <Contact alt='EOC Image' img={EOC}>
          <ContactText variant='bold'>
            Emergency Operation Center (EOC)
          </ContactText>
          <ContactText>
            Phone Numbers:
            <br />
            (808) 449-1979
            <br />
            (808) 448-3262
            <br />
            (808) 448-2557
            <br />
            (808) 448-2570
            <br />
            (808) 448-2583
          </ContactText>
          <ContactText>Email: jbphh-water-response@navy.mil</ContactText>
        </Contact>
        <Contact alt='TLA Housing line Image' img={TLAHousingLine}>
          <ContactText variant='bold'>TLA Housing LIne</ContactText>
          <ContactText>Phone: 808-789-5287</ContactText>
        </Contact>
      </Box>
    </Box>
  );
};

export { ContactList };
